// html2pdf.bundle.min.js is ~924 KiB and is needed only when the user
// exports a PDF, so index.html deliberately does not load it. The first
// export injects the script once; every later export reuses the same
// instance. Loading it from our own origin keeps `script-src 'self'` happy.
let html2pdfPromise = null;
function loadHtml2pdf() {
  if (window.html2pdf) return Promise.resolve(window.html2pdf);
  if (!html2pdfPromise) {
    html2pdfPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = '/html2pdf.bundle.min.js';
      script.async = true;
      script.onload = () => {
        if (window.html2pdf) resolve(window.html2pdf);
        else reject(new Error('html2pdf loaded but did not expose window.html2pdf'));
      };
      script.onerror = () => {
        // Clear the cached promise so the next export attempt retries.
        html2pdfPromise = null;
        reject(new Error('Failed to load the PDF library'));
      };
      document.head.appendChild(script);
    });
  }
  return html2pdfPromise;
}

export { loadHtml2pdf };
